import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { isObject as _isObject } from 'lodash';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';
import { getThumbFileFromEntity } from 'helpers/items';

import FormImageWithPreview from 'components/forms/FormImageWithPreview';

class ModelAssetData extends React.Component {
  changeEntity = (propertyName, value) => {
    const { entity, changeEntity } = this.props;

    const newEntity = { ...entity.updateValue(propertyName, value) };

    changeEntity(newEntity);
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      formStatusImage,
      doNotify,
    } = this.props;

    if (prevProps.formStatusImage.pending && !formStatusImage.pending && !formStatusImage.hasError) {
      // image has been uploaded, update the entity
      const value = this.props.entity.createValue('image', [], formStatusImage.response);
      const newEntity = { ...this.props.entity.updateValue('image', value) };
      this.props.changeEntity(newEntity);

      doNotify(1, messages.file_uploaded);
    }
  };

  fileUpload = (name, images) => {
    if (_isObject(images) && images.length === 1) {
      const fd = new FormData();
      fd.append('image', images[0]);

      this.props.uploadAsset(fd);
    }
  };

  fileReset = name => {
    this.updateEntity(name, null);
  };

  render() {
    const {
      intl: { messages },
      entityLoaded,
      entity,
      inModal,
    } = this.props;

    let imageUrl;
    if (entityLoaded) {
      if (entity.getImage().getId()) {
        const thumbnail = getThumbFileFromEntity(entity.getImage());
        if (thumbnail) {
          imageUrl = thumbnail.getWebLink();
        }
      }
    }

    return (
      <div className="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div className="panel panel-transparent">
                <div className="panel-body">
                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div className="form-group-attached">
                    <FormImageWithPreview
                      label={messages.image}
                      name="image"
                      url={imageUrl}
                      onChange={this.fileUpload}
                      onReset={this.fileReset}
                      pending={this.props.formStatusImage.pending}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
ModelAssetData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    formStatusImage: state.formStatus.modelAssetImage,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    uploadAsset: args => {
      formStatusDispatchHelper('modelAssetImage', '/api/modelassetsupload.json', args, 'post', dispatch);
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ModelAssetData)
);
